module.exports = __webpack_public_path__ + "img/Fish.0643f8a0.svg";